import React from "react";
import Skeleton from "@material-ui/lab/Skeleton/Skeleton";

export const FieldSkeleton = () => (
    <React.Fragment>
        <Skeleton  variant="rect" height={50} />
    </React.Fragment>
)